import { styled } from '@mui/material/styles'
import { Box, Typography } from '@mui/material'

export const TopbarReportsContainer = styled(Box)(`
  display: flex;
  align-items: center;
  height: 56px;
  background-color: #F6F6F5;
  padding: 0px 20px;
  gap: 20px;
  width: auto;
  // border:1px red solid;
`)

export const InnerContent = styled(Box)(`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`)

export const LeftSideContainer = styled(Box)(`
  display: flex;
  align-items: center;
`)

export const IconWrapper = styled(Box)(`
  display: flex;
  align-items: center;
  margin: 0 8px;

  svg {
    font-size: 12px;
  }
`)

export const BoldText = styled(Typography)(`
  font-weight: 600; // 500;
  font-size: 19px;
  width: 157px;
  line-height: 24px;
`)

export const OptionTitle = styled(Typography)(`
  font-weight: 100;
  font-size: 19px;
  width: 57px;
  line-height: 24px;
  color: #686867;
  font-weight: 400;
  font-size: 19px;
`)

export const RightSideContainer = styled(Box)(`
  display: flex;
  align-items: center;
  height: 34px;
  gap: 16px;
`)

export const AskIaPlaceholder = styled('button')(`
  all: unset;
`)

export const ExportButton = styled('button')(`
  height: 28px;
  display: flex;
  align-items: center;
  border: 1px solid #000;
  border-radius: 4px;
  font-size: 13px;
  gap: 4px;
  padding: 0px 10px;

  &:hover {
    border-color: #095bbd;
    color: #095bbd;
  }

  &:active {
    background-color: #063d7e;
  }
`)

export const SandboxButton = styled('button')(`
  height: 28px;
  width: 106px;
  display: flex;
  gap: 4px;
  align-items: center;
  border: 1px solid #000;
  border-radius: 4px;
  background-color: #000;
  color: #fff;
  font-size: 14px;
  padding: 4px 10px;

  &:hover {
    background-color: #095bbd;
    border-color: #095bbd;
    color: #fff;
  }

  &:active {
    background-color: #063d7e;
  }
`)
